import { API_ENDPOINTS } from "../../../../Api/apiEndPoints";
import axiosInstance from "../../../../Api/axiosInstance";

export const getCustomerTag = async (params?: Record<string, any>) => {
    const response = await axiosInstance.get(
        API_ENDPOINTS.Cutomer.GET_OUTLET_TAGS_LIST,
        { params: params }
    );
    console.log("🚀 ~ file: CustomerTagRepository.ts ~ line 9 ~ getCustomerTag ~ response", response);
    return response;
}

export const addCustomerTag = async (body: any) => {
    return axiosInstance.post(API_ENDPOINTS.Cutomer.ADD_OUTLET_TAG, body);
};
export const updateCustomerTag = async (body: any) => {
    return axiosInstance.put(`${API_ENDPOINTS.Cutomer.UPDATE_OUTLET_TAG}`, body);
};